import { render } from "./AccountSubmissionsView.vue?vue&type=template&id=484e368a&scoped=true"
import script from "./AccountSubmissionsView.vue?vue&type=script&lang=js"
export * from "./AccountSubmissionsView.vue?vue&type=script&lang=js"

import "./AccountSubmissionsView.vue?vue&type=style&index=0&id=484e368a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484e368a"]])

export default __exports__